import { Component, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms'; // Add this import
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-misobras',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule], // Add ReactiveFormsModule here
  templateUrl: './misobras.component.html',
  styleUrl: './misobras.component.css'
})
export class MisobrasComponent {

  formulario: FormGroup;
  selectedFile: File | null = null;
  selectedPages: File[] = [];
  isDragging = false;
  isDraggingPages = false;

  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef; // Ensure correct usage
  @ViewChild('fileInputPages', { static: false }) fileInputPages!: ElementRef; // Add this

  constructor(private fb: FormBuilder) {
    this.formulario = this.fb.group({
      titulo: ['', Validators.required],
      presentacion: [''],
      genero: [''],
      idioma: ['ES'],
      tipoEntrega: ['serie'],
      serieConcluida: [false],
      portada: [null] // Add this control
    });
  }

  triggerFileInput() {
    this.fileInput.nativeElement.click();
  }

  triggerFileInputPages() {
    this.fileInputPages.nativeElement.click();
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.selectedFile = file;
    }
  }

  onFilesSelectedPages(event: any) {
    const files = event.target.files;
    for (let i = 0; i < files.length; i++) {
      this.selectedPages.push(files[i]);
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    this.isDragging = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    this.isDragging = false;
    const dataTransfer = event.dataTransfer;
    if (dataTransfer) {
      const file = dataTransfer.files[0];
      if (file) {
        this.selectedFile = file;
      }
    }
  }

  onDragOverPages(event: DragEvent) {
    event.preventDefault();
    this.isDraggingPages = true;
  }

  onDragLeavePages(event: DragEvent) {
    event.preventDefault();
    this.isDraggingPages = false;
  }

  onDropPages(event: DragEvent) {
    event.preventDefault();
    this.isDraggingPages = false;
    const dataTransfer = event.dataTransfer;
    if (dataTransfer) {
      const files = dataTransfer.files;
      for (let i = 0; i < files.length; i++) {
        this.selectedPages.push(files[i]);
      }
    }
  }

  removeFile() {
    this.selectedFile = null;
  }

  removePage(index: number) {
    this.selectedPages.splice(index, 1);
  }

  formatSize(size: number): string {
    return `${(size / 1024).toFixed(2)} KB`;
  }

  enviarFormulario() {
    if (this.formulario.valid) {
      const formData = new FormData();
      formData.append('titulo', this.formulario.get('titulo')?.value);
      formData.append('presentacion', this.formulario.get('presentacion')?.value);
      formData.append('genero', this.formulario.get('genero')?.value);
      formData.append('idioma', this.formulario.get('idioma')?.value);
      formData.append('tipoEntrega', this.formulario.get('tipoEntrega')?.value);
      formData.append('serieConcluida', this.formulario.get('serieConcluida')?.value);

      if (this.selectedFile) {
        formData.append('portada', this.selectedFile);
      }

      this.selectedPages.forEach((file, index) => {
        formData.append(`pagina_${index}`, file);
      });

      // Implement the logic to send formData to the server
      console.log('Form data:', formData);
    }
  }

}
